import { render } from "./CambiarCita.vue?vue&type=template&id=3b245f7a&scoped=true"
import script from "./CambiarCita.vue?vue&type=script&lang=js"
export * from "./CambiarCita.vue?vue&type=script&lang=js"

import "./CambiarCita.vue?vue&type=style&index=0&id=3b245f7a&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b245f7a"]])

export default __exports__